(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gcc-christmas-landing"]) return;
  try {
    
(function(){
  const root=document.querySelector('.gxl'); if(!root) return;
  const TIERS=[[12,.12],[5,.07],[3,.03]];
  const FREE_SHIP=Number(root.dataset.freeShip)||99, PAGE=24;
  const TYPE_ORDER=["Tumbler 20oz","Mug","Ornament","Santa tray","UV DTF cup wrap","UV DTF decal","DTF for shirts","Tumbler 40oz","Tumbler 30oz","Kids cup 12oz","Glass can 16oz","Shot glass decal","Car coaster","Coaster","Notebook sticker","Paperclip","Mouse pad","Keychain","Straw topper","Wind spinner","Other"];
  const $=id=>document.getElementById(id);
  const money=v=>"$"+v.toFixed(2);
  const esc=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/"/g,"&quot;");
  const tierFor=q=>(TIERS.find(t=>q>=t[0])||[0,0])[1];
  let ITEMS=[], byV={}, qty={}, FD="all", FT="all", SHOWN=PAGE;

  function split(t){
    const parts=t.split(/\s*-\s+|\s+-\s*/);
    const n=parts.shift().trim();
    const f=parts.join(" - ").replace(/\s*(Regular )?Sublimation (Wrap|Transfers?)\s*$/i,"").trim();
    return [n,f];
  }
  async function load(){
    const base=root.dataset.dataPath;
    let page=1, pages=1, out=[];
    do{
      const r=await fetch(`${base}?view=xmas-data&page=${page}`,{credentials:"same-origin"});
      const d=await r.json(); pages=d.pages||1; out=out.concat(d.items); page++;
    }while(page<=pages);
    ITEMS=out.filter(i=>i.v&&i.m).map(i=>{const [n,f]=split(i.t);return{n,f,h:i.h,u:i.url,img:i.img,p:i.p/100,v:String(i.v),q:i.q,many:i.many,t:i.m.type||"Other",d:i.m.design||"More Christmas",r:i.m.rank||9999,b:i.m.badges||[]}})
      .sort((a,b)=>a.r-b.r);
    ITEMS.forEach(i=>{byV[i.v]=i; qty[i.v]=qty[i.v]||0});
    try{const c=await (await fetch(`${root.dataset.root.replace(/\/$/,"")}/cart.js`)).json(); c.items.forEach(l=>{if(byV[l.variant_id]) qty[l.variant_id]=l.quantity})}catch(e){}
    fillSelects(); renderGrid(); renderBar();
  }
  const DESIGNS=()=>[...new Set(ITEMS.map(i=>i.d))].sort((a,b)=>a==="More Christmas"?1:b==="More Christmas"?-1:ITEMS.filter(i=>i.d===b).length-ITEMS.filter(i=>i.d===a).length);
  function fillSelects(){
    const cnt=(k,v,o,ov)=>ITEMS.filter(i=>i[k]===v&&(ov==="all"||i[o]===ov)).length;
    $("gxl-fDesign").innerHTML=`<option value="all">All designs (${ITEMS.filter(i=>FT==="all"||i.t===FT).length})</option>`+DESIGNS().map(d=>{const n=cnt("d",d,"t",FT);return `<option value="${esc(d)}" ${n?"":"disabled"} ${d===FD?"selected":""}>${esc(d)} (${n})</option>`}).join("");
    $("gxl-fType").innerHTML=`<option value="all">All products (${ITEMS.filter(i=>FD==="all"||i.d===FD).length})</option>`+TYPE_ORDER.filter(t=>ITEMS.some(i=>i.t===t)).map(t=>{const n=cnt("t",t,"d",FD);return `<option value="${esc(t)}" ${n?"":"disabled"} ${t===FT?"selected":""}>${esc(t)} (${n})</option>`}).join("");
    root.querySelector('label[for="gxl-fDesign"]').classList.toggle("on",FD!=="all");
    root.querySelector('label[for="gxl-fType"]').classList.toggle("on",FT!=="all");
    $("gxl-clear").hidden=FD==="all"&&FT==="all";
  }
  function badges(i){
    const o=[];
    if(i.b.includes("best")) o.push(`<span class="gxl-badge gxl-b-best"><i class="ph-fill ph-star" aria-hidden="true"></i>Best seller</span>`);
    if(i.b.includes("trend")) o.push(`<span class="gxl-badge gxl-b-trend"><i class="ph-bold ph-trend-up" aria-hidden="true"></i>Trending</span>`);
    if(i.q!==null&&i.q>0&&i.q<=5) o.push(`<span class="gxl-badge gxl-b-low"><i class="ph-bold ph-hourglass-medium" aria-hidden="true"></i>Only ${i.q} left</span>`);
    return o.join("");
  }
  function hint(i){
    const q=qty[i.v];
    if(q===0) return `${money(i.p)} each`;
    const next=[...TIERS].reverse().find(t=>q<t[0]), now=tierFor(q);
    if(!next) return `<b>12% off this design</b>`;
    const more=next[0]-q, pct=Math.round(next[1]*100);
    return now?`<b>${Math.round(now*100)}% off</b>. Add ${more} for ${pct}%`:`Add ${more} more for <b>${pct}% off</b>`;
  }
  function control(i){
    const q=qty[i.v];
    if(i.many) return `<a class="gxl-btn gxl-btn-dark gxl-add" href="${i.u}">Choose options</a>`;
    return q===0?`<button class="gxl-btn gxl-btn-dark gxl-add" data-add="${i.v}">Add to cart</button>`
      :`<div class="gxl-stepper"><button data-dec="${i.v}" aria-label="Remove one ${esc(i.n)}"><i class="ph-bold ph-minus" aria-hidden="true"></i></button><output aria-label="Quantity">${q}</output><button data-inc="${i.v}" aria-label="Add one ${esc(i.n)}"><i class="ph-bold ph-plus" aria-hidden="true"></i></button></div>`;
  }
  const tile=i=>`<article class="gxl-tile" id="gxl-t-${i.v}">
    <a class="gxl-ph" href="${i.u}" tabindex="-1" aria-hidden="true"><img src="${i.img}" alt="" loading="lazy" width="500" height="500"></a>
    <div class="gxl-badges">${badges(i)}</div>
    <h3><a href="${i.u}">${esc(i.n)}</a></h3>
    <div class="gxl-meta"><span class="gxl-fmt" title="${esc(i.f)}">${esc(i.f||i.t)}</span><span class="gxl-price">${money(i.p)}</span></div>
    <div class="gxl-hint">${hint(i)}</div>
    <div class="gxl-ctl">${control(i)}</div></article>`;
  const list=()=>ITEMS.filter(i=>(FD==="all"||i.d===FD)&&(FT==="all"||i.t===FT));
  function renderGrid(){
    const L=list(), n=Math.min(SHOWN,L.length);
    $("gxl-grid").innerHTML=L.slice(0,n).map(tile).join("");
    const what=[FD!=="all"?FD:"",FT!=="all"?FT.toLowerCase():""].filter(Boolean).join(" · ");
    $("gxl-count").textContent=`${L.length} ${what?what+" designs":"Christmas designs"} in stock, best sellers first.`;
    $("gxl-moreRow").hidden=n>=L.length;
    $("gxl-moreTxt").textContent=`Showing ${n} of ${L.length}`;
    $("gxl-moreBar").style.transform=`scaleX(${L.length?n/L.length:0})`;
  }
  function refreshTile(i){const t=$("gxl-t-"+i.v); if(!t)return; t.querySelector(".gxl-ctl").innerHTML=control(i); t.querySelector(".gxl-hint").innerHTML=hint(i)}
  function totals(){let units=0,gross=0,net=0; for(const v in qty){const q=qty[v]; if(!q)continue; const i=byV[v]; units+=q; gross+=q*i.p; net+=q*i.p*(1-tierFor(q))} return{units,gross,net,save:gross-net}}
  function renderBar(){
    const t=totals();
    $("gxl-cartbar").classList.toggle("on",t.units>0);
    $("gxl-sum").innerHTML=`<strong>${t.units} ${t.units===1?"item":"items"} · ${money(t.net)}</strong>${t.save>0?`<span class="gxl-sv">You save ${money(t.save)}</span>`:"Discount applies per design at checkout"}`;
    const left=FREE_SHIP-t.net;
    $("gxl-shipFill").style.transform=`scaleX(${Math.min(1,t.net/FREE_SHIP)})`;
    $("gxl-shipTxt").textContent=left>0?`${money(left)} away from free shipping`:"Free shipping unlocked";
  }
  let toastT;
  function toast(m){const el=$("gxl-toast");el.textContent=m;el.classList.add("on");clearTimeout(toastT);toastT=setTimeout(()=>el.classList.remove("on"),1800)}
  async function refreshBubble(){
    try{
      const r=await fetch(`${root.dataset.root.replace(/\/$/,"")}/?sections=cart-icon-bubble`); const d=await r.json();
      const b=document.getElementById("cart-icon-bubble"); if(!b||!d["cart-icon-bubble"])return;
      const doc=new DOMParser().parseFromString(d["cart-icon-bubble"],"text/html");
      const inner=doc.querySelector(".shopify-section"); if(inner) b.innerHTML=inner.innerHTML;
    }catch(e){}
  }
  const cartFetch=(...a)=>(window.__kachingCartOriginalFetch||window.fetch).apply(window,a);
  async function sync(i,prev){
    const base=root.dataset.root.replace(/\/$/,"");
    try{
      let r;
      if(prev===0) r=await cartFetch(`${base}/cart/add.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:Number(i.v),quantity:qty[i.v]}]})});
      else r=await cartFetch(`${base}/cart/change.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:i.v,quantity:qty[i.v]})});
      if(!r.ok){const e=await r.json().catch(()=>({})); throw new Error(e.description||"")}
      refreshBubble(); try{window.kachingCartApi&&window.kachingCartApi.refreshCart&&window.kachingCartApi.refreshCart()}catch(e){} return true;
    }catch(e){qty[i.v]=prev; toast(e.message&&/stock|available/i.test(e.message)?"No more units of this design in stock.":"We couldn't update your cart. Try again."); return false}
  }
  async function setQty(v,q){
    const i=byV[v], prev=qty[v];
    let n=Math.max(0,Math.min(99,q)); if(i.q!==null&&i.q>0) n=Math.min(n,i.q);
    if(n===prev){ if(q>prev) toast("No more units of this design in stock."); return }
    qty[v]=n; refreshTile(i); renderBar();
    if(!(await sync(i,prev))){refreshTile(i);renderBar();return}
    if(prev===0&&qty[v]>0) toast(`${i.n} added`);
  }
  $("gxl-grid").addEventListener("click",e=>{
    const b=e.target.closest("button[data-add],button[data-inc],button[data-dec]"); if(!b)return;
    if(b.dataset.add) setQty(b.dataset.add,1);
    if(b.dataset.inc) setQty(b.dataset.inc,qty[b.dataset.inc]+1);
    if(b.dataset.dec) setQty(b.dataset.dec,qty[b.dataset.dec]-1);
  });
  function apply(){SHOWN=PAGE; fillSelects(); renderGrid(); const top=$("gxl-count").getBoundingClientRect().top; if(top<0||top>innerHeight*.6) $("gxl-count").scrollIntoView({block:"start"})}
  $("gxl-fDesign").addEventListener("change",e=>{FD=e.target.value;apply()});
  $("gxl-fType").addEventListener("change",e=>{FT=e.target.value;apply()});
  $("gxl-clear").addEventListener("click",()=>{FD="all";FT="all";apply()});
  $("gxl-checkout").addEventListener("click",e=>{if(window.kachingCartApi&&window.kachingCartApi.openCart){e.preventDefault();window.kachingCartApi.openCart()}});
  $("gxl-moreBtn").addEventListener("click",()=>{SHOWN+=PAGE;renderGrid()});
  document.addEventListener("gcc:cart-changed",async()=>{
    try{const c=await (await fetch(`${root.dataset.root.replace(/\/$/,"")}/cart.js`)).json(); for(const v in qty) qty[v]=0; c.items.forEach(l=>{if(byV[l.variant_id]) qty[l.variant_id]=l.quantity}); renderGrid(); renderBar()}catch(e){}
  });
  load().catch(()=>{$("gxl-count").textContent="We couldn't load the designs. Refresh the page to try again."; $("gxl-grid").innerHTML=""});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
